var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolAiModule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10757_103255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0026 3.33203H5.0026C4.08213 3.33203 3.33594 4.07822 3.33594 4.9987V14.9987C3.33594 15.9192 4.08213 16.6654 5.0026 16.6654H15.0026C15.9231 16.6654 16.6693 15.9192 16.6693 14.9987V4.9987C16.6693 4.07822 15.9231 3.33203 15.0026 3.33203Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.832031V3.33203",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.832031V3.33203",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.668V19.168",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.668V19.168",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 7.5H19.1641",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 11.668H19.1641",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 7.5H3.33594",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 11.668H3.33594",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44897 12.4015L7.88695 11.184H9.79529L10.2333 12.4015C10.2761 12.5206 10.389 12.6 10.5156 12.6H10.7304C10.9395 12.6 11.0845 12.3914 11.0115 12.1954L9.29997 7.59538C9.25626 7.47792 9.14414 7.4 9.0188 7.4H8.66344C8.5381 7.4 8.42597 7.47792 8.38227 7.59538L6.67071 12.1954C6.59778 12.3914 6.74274 12.6 6.95187 12.6H7.16668C7.29321 12.6 7.40614 12.5206 7.44897 12.4015ZM8.84112 8.53143L9.53014 10.4469H8.1521L8.84112 8.53143ZM12.5974 12.3V7.7C12.5974 7.53431 12.4631 7.4 12.2974 7.4H12.0839C11.9182 7.4 11.7839 7.53431 11.7839 7.7V12.3C11.7839 12.4657 11.9182 12.6 12.0839 12.6H12.2974C12.4631 12.6 12.5974 12.4657 12.5974 12.3Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10757_103255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolAiModule);
export default __webpack_public_path__ + "static/media/tool_ai_module.7665fdf019f0afa191970d93bea90b5a.svg";
export { ForwardRef as ReactComponent };